<template>
  <!-- pop-repeat-edit-torim -->
  <div class="popup_in">
    <div class="popup pop-repeat-edit-torim">
      <div class="popup_close bg--blue">
        <a href="javascript:void(0)" @click.prevent="onOutside"><CloseSvg /></a>
      </div>
      <div class="title bold">
        לא ניתן {{ title }} יומן עתידי ללא שינוי מועדי התור הקיימים
      </div>
      <div class="text">{{ block.end_date }}</div>
      <div class="pop-repeat-scroll has--scroll">
        <div
          class="pop-repeat-row bg--white relative flex flex--top"
          v-for="app in appointments"
          :key="app.id"
        >
          <div class="text bold">
            {{ `${$moment(app.start).format("HH:mm")}` }}
          </div>
          <div class="text is--fit">
            {{
              `  ${app.patientName}  ${app.passport} | ${app.appointment_name}  ${app.patient_phone} | `
            }}
          </div>
          <div
            class="Pen flex flex--content--center pointer"
            @click="goToAppInfo(app.id)"
          >
            <Pen />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End pop-repeat-edit-torim -->
</template>

<script>
import { mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import { getHash } from "../../utilities/hash.js";
import CloseSvg from "@/assets/img/svg/close.svg";
import Pen from "@/assets/img/svg/pen-blue.svg";

export default {
  name: "EditBlockInvalidPop",
  props: ["block", "title"],
  data() {
    return {
      appointments: []
    };
  },
  computed: {
    ...mapGetters(["activeUser", "activeDoctor"])
  },
  methods: {
    goToAppInfo(app_id) {
      this.$router.push({ name: "app-edit", params: { id: app_id } });
      this.$emit("close");
    },
    onOutside() {
      window.location.hash = getHash({ blockId: "" });
      const hash = JSON.parse(localStorage.getItem("hashData"));
      const { blockId, ...updatedHash } = hash;
      localStorage.setItem("hashData", JSON.stringify(updatedHash));
      this.$emit("close");
    }
  },
  mounted() {
    this.$API
      .getFullCalendarEvents(
        this.activeUser.user_id,
        this.activeDoctor.id,
        "appointment",
        "",
        "",
        this.block.id
      )
      .then(response => {
        const apps = response.filter(
          obj => typeof obj.appointment_id != "undefined"
        );
        const sortedByTime = apps.sort((a, b) => {
          let aa = this.$moment(a.start).format("HH:mm");
          let bb = this.$moment(b.start).format("HH:mm");
          return aa < bb ? -1 : aa > bb ? 1 : 0;
        });

        this.appointments = sortedByTime;
      });
  },
  components: {
    CloseSvg,
    Pen
  },
  directives: {
    ClickOutside
  }
};
</script>
